<template>
  <div ref="chartRef" :style="{ width, height }" v-show="showECharts"></div>
  <Empty :style="{ width, height }" v-if="!showECharts"/>
</template>
  
  <script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import Empty from './Empty.vue'

const props = defineProps({
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '240px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  }
})
const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
watch(
  () => props.data,
  (v) => {
    initChart()
  }
)
const initChart = () => {
  showECharts.value = props.data.length > 0
  const option = {
    tooltip: {
      trigger: 'item',
      backgroundColor: '#000',
      textStyle: {
        color: '#fff'
      },
      // formatter: function (params) {
      //   return props.data[params[0].dataIndex].tooltip
      // }
    },
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        min: 0,
        radius: '90%',
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false
        },
        axisLine: {
          lineStyle: {
            width: 20
          }
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        data: props.data,
        title: {
          fontSize: 16,
          color: '#5B687D',
          offsetCenter: ['0%', '15%']
        },
        detail: {
          fontSize: 26,
          offsetCenter: ['0%', '-15%'],
          color: '#26292E',
          formatter: '{value}%'
        }
      }
    ]
  }
  setOptions(option)
}

onMounted(() => {
  initChart()
})
</script>
  <script lang="ts">
export default { name: 'BoardGaugeChart' }
</script>
  <style scoped></style>
  